import type paymentsEn from "./payments.en";

const paymentsAr: Record<keyof typeof paymentsEn, string> = {
  "settings.payments": "طرق الدفع",
  "settings.payments_hint": "مزودو الدفع بالبطاقة، الدفع لاحقاً، الدفع عند الاستلام والتحويل البنكي",
  "pay.title": "المدفوعات",
  "pay.none_active": "لا توجد طرق دفع مفعّلة: لا يستطيع العملاء إتمام الطلب بعد.",
  "pay.dev_store": "هذا متجر تطوير: تعمل المدفوعات دائماً في وضع الاختبار.",
  "pay.providers": "مزودو الدفع",
  "pay.providers_hint": "اقبل بطاقات الائتمان والخصم. يدفع العملاء في صفحة المزود الآمنة. يمكن تفعيل مزود بطاقات واحد فقط في كل مرة.",
  "pay.pay_later": "الدفع لاحقاً",
  "pay.pay_later_hint": "يقسّم العملاء المشتريات على دفعات بدون فوائد. يدفع لك المزود ويحصّل من العميل.",
  "pay.pci": "تُدخل بيانات البطاقة في صفحة المزود ولا تصل أبداً إلى متجرك.",
  "pay.active": "مفعّل",
  "pay.inactive": "غير مفعّل",
  "pay.test_mode": "وضع الاختبار",
  "pay.manage": "إدارة",
  "pay.activate": "تفعيل",
  "pay.deactivate": "إيقاف",
  "pay.unavailable": "غير متاح لعملة {cur}",
  "pay.manual": "طرق الدفع اليدوية",
  "pay.manual_hint": "مدفوعات تتم خارج متجرك. تبقى الطلبات معلّقة حتى تحددها كمدفوعة.",
  "pay.cod": "الدفع عند الاستلام",
  "pay.cod_hint": "يدفع العملاء عند تسليم الطلب.",
  "pay.cod_intro": "يدفع العملاء للسائق نقداً (أو بالبطاقة إذا كان مع السائق جهاز دفع).",
  "pay.fee_percent": "الرسوم: {n}% من الطلب",
  "pay.fee_fixed": "الرسوم: {n}",
  "pay.fee": "رسوم الدفع عند الاستلام",
  "pay.fee_none": "بدون رسوم",
  "pay.fee_type_fixed": "مبلغ ثابت ({cur})",
  "pay.fee_type_percent": "نسبة من الطلب",
  "pay.fee_percent_label": "الرسوم (%)",
  "pay.fee_amount": "الرسوم ({cur})",
  "pay.min_total": "الحد الأدنى للطلب ({cur})",
  "pay.max_total": "الحد الأقصى للطلب ({cur})",
  "pay.max_total_hint": "الطلبات الأكبر يجب دفعها إلكترونياً.",
  "pay.instructions": "تعليمات الدفع",
  "pay.instructions_hint": "تظهر عند إتمام الطلب، مثل «جهّز المبلغ المطلوب بالضبط».",
  "pay.bank": "تحويل بنكي",
  "pay.bank_hint": "يحوّل العملاء المبلغ إلى حسابك البنكي.",
  "pay.bank_intro": "يرى العملاء هذه البيانات عند إتمام الطلب وفي تأكيد الطلب. حدّد الطلب كمدفوع عند وصول المبلغ.",
  "pay.bank_details": "بيانات الحساب البنكي",
  "pay.bank_details_hint": "اسم البنك واسم الحساب والآيبان، وما يُكتب كمرجع للتحويل (مثل رقم الطلب).",
  "pay.custom": "طريقة دفع مخصصة",
  "pay.custom_hint": "طريقتك الخاصة، مثل الدفع في متجرك أو بشيك.",
  "pay.custom_intro": "يرى العملاء هذا الاسم والتعليمات عند إتمام الطلب وفي تأكيد الطلب.",
  "pay.custom_name": "الاسم",
  "pay.custom_name_hint": "يظهر عند إتمام الطلب، مثل «الدفع في المتجر».",
  "pay.manage_title": "{name}",
  "pay.activate_title": "تفعيل {name}",
  "pay.how_to": "طريقة إعداد {name}",
  "pay.signup": "فتح حساب",
  "pay.docs": "وثائق المطورين",
  "pay.only_currencies": "يقبل {name} المدفوعات بـ {list}. عملة متجرك {cur}، لذلك لن يظهر للعملاء.",
  "pay.blank_keeps": "اترك الحقل فارغاً للإبقاء على القيمة المحفوظة. تُشفَّر المفاتيح المحفوظة ولا تظهر مرة أخرى.",
  "pay.portal_setup": "في حسابك لدى {name}",
  "pay.portal_setup_hint": "الصق هذه القيم حيث تشير الخطوات أعلاه، ليعود العملاء إلى متجرك وتُؤكَّد المدفوعات.",
  "pay.return_url": "رابط العودة",
  "pay.webhook_url": "رابط Webhook",
  "pay.copy": "نسخ",
  "pay.copied": "تم النسخ",
  "pay.test_mode_label": "وضع الاختبار",
  "pay.test_mode_hint": "يستخدم بيئة الاختبار لدى المزود ومفاتيح الاختبار: لا تُحوّل أموال حقيقية. أوقفه لقبول مدفوعات حقيقية.",
  "pay.enable": "عرض {name} عند إتمام الطلب",
  "pay.enable_cards_hint": "يرى العملاء «بطاقة ائتمان / خصم» ويدفعون في صفحة {name}.",
  "pay.enable_later_hint": "يرى العملاء «ادفع لاحقاً مع {name}» ويقدّمون الطلب في صفحة {name}.",
  "pay.test_connection": "اختبار الاتصال",
  "pay.connection_ok": "قَبِل {name} بيانات الاعتماد",
  "pay.choose_country": "اختر الدولة",

  "pay.field.client_id": "Client ID",
  "pay.field.key_id": "Key ID",
  "pay.field.key_secret": "Key secret",
  "pay.field.key_secret_hint": "القيمة الطويلة الظاهرة بجانب Key ID، وليست مفتاح Webhook.",
  "pay.field.webhook_key": "مفتاح Webhook",
  "pay.field.webhook_key_hint": "يتيح التحقق من أن إشعارات Webhook صادرة من المزود.",
  "pay.field.secret_key": "المفتاح السري",
  "pay.field.secret_key_hint": "استخدم مفتاح الاختبار في وضع الاختبار والمفتاح المباشر للمدفوعات الحقيقية.",
  "pay.field.api_key": "مفتاح API (الرمز)",
  "pay.field.api_key_hint": "يُنشأ في بوابة ماي فاتورة من إعدادات التكامل ← مفتاح API.",
  "pay.field.country": "دولة الحساب",
  "pay.field.country_hint": "الدولة المسجّل فيها حسابك، وتحدد الخادم الذي نستخدمه.",
  "pay.field.webhook_secret": "المفتاح السري لـ Webhook",
  "pay.field.webhook_secret_hint": "اختياري. يتيح التحقق من أن الإشعارات صادرة من المزود.",
  "pay.field.client_secret": "Client secret",
  "pay.field.client_secret_hint": "يرسله مدير حسابك في PayLater مع Client ID.",
  "pay.field.outlet_id": "رقم المنفذ (Outlet ID)",
  "pay.field.outlet_id_hint": "رقم منفذك الإلكتروني (المتجر) لدى PayLater.",
  "pay.gw.paylater.hint": "تطبيق الدفع لاحقاً في قطر: أقساط بدون فوائد للطلبات من 300 إلى 25,000 ريال قطري.",
  "pay.gw.paylater.steps": "سجّل كتاجر لدى PayLater: تواصل معهم (tech@paylaterapp.com أو مدير حسابك). يرسلون Client ID وClient secret ورقم المنفذ، بيانات بيئة الاختبار أولاً، ثم بيانات الإنتاج بعد الإطلاق.\nأدخل Client ID وClient secret ورقم المنفذ أدناه. في وضع الاختبار استخدم بيانات بيئة الاختبار.\nاطلب من مدير حسابك المفتاح السري لـ Webhook وأدخله أدناه، وأرسل له رابط Webhook الظاهر أدناه ليُبلغ PayLater متجرك بحالة الدفع.\nاحفظ ثم اختبر الاتصال. يرى العملاء PayLater عند إتمام الطلب للطلبات بين 300 و25,000 ريال قطري.",
  "pay.field.merchant_id": "رقم التاجر (Merchant ID)",
  "pay.field.merchant_id_hint": "الرقم الظاهر في بوابة الدفع داخل لوحة سداد.",
  "pay.field.website": "الموقع",
  "pay.field.website_hint": "النطاق الذي سجّلته لدى سداد، مثل mystore.com.",
  "pay.field.merchant_code": "رمز التاجر",
  "pay.field.merchant_code_hint": "يرسله مدير التكامل لدى تابي.",
  "pay.field.api_token": "رمز API",
  "pay.field.api_token_hint": "استخدم رمز بيئة الاختبار في وضع الاختبار.",
  "pay.field.notification_token": "رمز الإشعارات",
  "pay.field.notification_token_hint": "يتيح التحقق من أن الإشعارات صادرة من تمارا.",

  "pay.gw.skipcash.hint": "بوابة الدفع في قطر. تُحوّل المبالغ إلى حسابك في SkipCash.",
  "pay.gw.skipcash.steps": "سجّل الدخول إلى بوابة التاجر في SkipCash وافتح الإعدادات ← مفاتيح API. في وضع الاختبار استخدم مفاتيح حساب الاختبار (Sandbox).\nانسخ Client ID وKey ID وKey secret ومفتاح Webhook إلى الحقول أدناه.\nفي الصفحة نفسها من البوابة، أدخل رابط العودة ورابط Webhook الظاهرين أدناه.\nاحفظ ثم اختبر الاتصال. أوقف وضع الاختبار عندما تكون جاهزاً لقبول مدفوعات حقيقية.",
  "pay.gw.skipcash.manager": "مدير حساب SkipCash:",
  "pay.gw.sadad.hint": "بوابة سداد في قطر للدفع بالبطاقات. تُحوّل المبالغ إلى حسابك في سداد.",
  "pay.gw.sadad.steps": "حمّل تطبيق SADAD Business QA وسجّل كتاجر وأكمل التحقق، ثم سجّل الدخول إلى panel.sadad.qa.\nفي اللوحة اختر المدفوعات الإلكترونية ثم بوابة الدفع. انسخ رقم التاجر والمفتاح السري: مفتاح الاختبار لوضع الاختبار، والمفتاح المباشر للمدفوعات الحقيقية.\nأدخل الموقع (النطاق) الذي سجّلته لدى سداد.\nمن بوابة الدفع ← Webhook، الصق رابط Webhook الظاهر أدناه واحفظ.\nاحفظ هنا ثم اختبر الاتصال. يرسل دعم سداد بطاقات الاختبار عند الطلب.",
  "pay.gw.myfatoorah.hint": "البطاقات وApple Pay وكي نت ومدى وبنفت في الخليج ومصر.",
  "pay.gw.myfatoorah.steps": "سجّل الدخول إلى بوابة ماي فاتورة وافتح إعدادات التكامل ← مفتاح API وأنشئ مفتاحك. لوضع الاختبار، سجّل حساباً تجريبياً في registertest.myfatoorah.com واستخدم رمزه.\nاختر الدولة المسجّل فيها حسابك في ماي فاتورة.\nاختياري ومستحسن: من إعدادات التكامل ← إعدادات Webhook فعّل الإشعارات واختر الإصدار 2، والصق رابط Webhook الظاهر أدناه، واختر حدث حالة الدفع، وانسخ المفتاح السري هنا.\nاحفظ ثم اختبر الاتصال. يرى العملاء كل طرق الدفع المفعّلة في حسابك لدى ماي فاتورة.",
  "pay.gw.tap.hint": "البطاقات وApple Pay ومدى وكي نت وبنفت في الخليج.",
  "pay.gw.tap.steps": "سجّل الدخول إلى لوحة Tap وافتح صفحة مفاتيح API (goSell ← API Credentials).\nانسخ المفتاح السري: الذي يبدأ بـ sk_test_ لوضع الاختبار، أو sk_live_ للمدفوعات الحقيقية.\nاحفظ ثم اختبر الاتصال. تُضبط إشعارات الدفع تلقائياً مع كل عملية، ولا حاجة للصق أي رابط في Tap.",
  "pay.gw.tabby.hint": "ادفع على 4 دفعات بدون فوائد. للمتاجر التي تبيع بالدرهم الإماراتي أو الريال السعودي.",
  "pay.gw.tabby.steps": "قدّم طلب حساب تاجر لدى تابي. يرسل لك مدير التكامل رمز التاجر ومفاتيح API.\nأدخل المفتاح السري (يبدأ بـ sk_test_ في وضع الاختبار) ورمز التاجر.\nاحفظ ثم اختبر الاتصال. تُحصّل المدفوعات المعتمدة تلقائياً عند إنشاء الطلب، وتدفع لك تابي.",
  "pay.gw.tamara.hint": "أقساط بدون فوائد. للمتاجر التي تبيع بالريال السعودي أو الدرهم أو الدينار الكويتي أو البحريني أو الريال العماني.",
  "pay.gw.tamara.steps": "قدّم طلب حساب تاجر لدى تمارا وسجّل الدخول إلى بوابة الشركاء.\nانسخ رمز API (رمز بيئة الاختبار لوضع الاختبار) ورمز الإشعارات.\nفي بوابة الشركاء، أضف رابط Webhook الظاهر أدناه كـ Webhook للطلبات مع اختيار حدث الموافقة (Approved).\nاحفظ ثم اختبر الاتصال. تُعتمد الطلبات الموافق عليها تلقائياً عند إنشاء الطلب، وتحصّلها تمارا خلال 21 يوماً.",
};

export default paymentsAr;
